import { render, staticRenderFns } from "./UIButtonGray.vue?vue&type=template&id=7bac4e24&scoped=true&"
import script from "./UIButtonGray.vue?vue&type=script&lang=js&"
export * from "./UIButtonGray.vue?vue&type=script&lang=js&"
import style0 from "./UIButtonGray.vue?vue&type=style&index=0&id=7bac4e24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bac4e24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bac4e24')) {
      api.createRecord('7bac4e24', component.options)
    } else {
      api.reload('7bac4e24', component.options)
    }
    module.hot.accept("./UIButtonGray.vue?vue&type=template&id=7bac4e24&scoped=true&", function () {
      api.rerender('7bac4e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/UIButtonGray.vue"
export default component.exports